import { basicInitialState } from '../../_utils/basicInitialState';
import { TCrmCompaniesState } from './CrmCompaniesModel';

export const CrmCompaniesInitialState: TCrmCompaniesState = {
  ...basicInitialState,
  crmCompanies: null
};
